import storage from 'good-storage'
import {
  SET_USER_INFO,
  SET_MENUS,
  SET_MENU_URL,
  CLEAR_USER_INFO,
} from 'config/mutation-types/user'
import {
  SET_COMPANY,
  SET_BUREAU,
  SET_PERMISSIONS,
  SET_SYS_NAME,
} from 'config/mutation-types/app'

export default store => {
  store.subscribe(mutation => {
    switch (mutation.type) {
      case `user/${SET_USER_INFO}`:
        storage.set('userInfo', mutation.payload)
        break
      case `user/${SET_MENUS}`:
        storage.set('userMenus', mutation.payload)
        break
      case `user/${SET_MENU_URL}`:
        storage.set('menuUrl', mutation.payload)
        break
      case `user/${CLEAR_USER_INFO}`:
        storage.clear()
        break
      case `app/${SET_COMPANY}`:
        storage.set('company', mutation.payload)
        break
      case `app/${SET_BUREAU}`:
        storage.set('bureauReportBasicInfo', mutation.payload)
        break
      case `app/${SET_PERMISSIONS}`:
        storage.set('permissions', mutation.payload)
        break
      case `app/${SET_SYS_NAME}`:
        storage.set('sysName', mutation.payload)
        break
    }
  })
}
